/* image-upload.js — single "add image" field for a product.
   Customer uploads -> preview -> view (lightbox) / change / remove.
   The hosted URL is saved as a line item property so the merchant sees it in the order.
   Intercepts fetch/XHR to /cart/add for AJAX themes. */
(function () {
  'use strict';

  function getAllImageProps() {
    var props = {};
    document.querySelectorAll('.imgup').forEach(function (el) {
      if (el._imgUpInstance && el._imgUpInstance.url) {
        props['_' + el._imgUpInstance.cfg.label] = el._imgUpInstance.url;
      }
    });
    return props;
  }

  function injectProps(data, props) {
    if (data.items) {
      data.items.forEach(function (item) {
        item.properties = Object.assign({}, item.properties || {}, props);
      });
    } else if (data.id) {
      data.properties = Object.assign({}, data.properties || {}, props);
    }
  }

  var ajaxPatched = false;
  function patchAjax() {
    if (ajaxPatched) return;
    ajaxPatched = true;

    var origFetch = window.fetch;
    window.fetch = function (url, opts) {
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';
      if (urlStr.indexOf('/cart/add') !== -1 && opts && opts.body) {
        try {
          var props = getAllImageProps();
          if (Object.keys(props).length > 0) {
            if (typeof opts.body === 'string') {
              var data = JSON.parse(opts.body);
              injectProps(data, props);
              opts = Object.assign({}, opts, { body: JSON.stringify(data) });
            } else if (opts.body instanceof FormData) {
              Object.keys(props).forEach(function (k) {
                opts.body.set('properties[' + k + ']', props[k]);
              });
            }
          }
        } catch (e) { /* skip */ }
      }
      return origFetch.apply(this, arguments);
    };

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._iuUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this._iuUrl && this._iuUrl.indexOf('/cart/add') !== -1 && typeof body === 'string') {
        try {
          var props = getAllImageProps();
          if (Object.keys(props).length > 0) {
            var data = JSON.parse(body);
            injectProps(data, props);
            body = JSON.stringify(data);
          }
        } catch (e) { /* skip */ }
      }
      return origSend.call(this, body);
    };
  }

  class ImageUpload {
    constructor(root) {
      this.root = root;
      root._imgUpInstance = this;
      var d = root.dataset;
      this.cfg = {
        service:  d.uploadService || 'imgbb',
        imgbbKey: d.imgbbApiKey || '',
        clCloud:  d.cloudinaryCloudName || '',
        clPreset: d.cloudinaryPreset || '',
        maxMb:    parseFloat(d.maxSizeMb) || 10,
        label:    d.propLabel || 'תמונה מצורפת',
        required: d.required === 'true'
      };
      this.input   = root.querySelector('.imgup__input');
      this.btn     = root.querySelector('.imgup__btn');
      this.preview = root.querySelector('.imgup__preview');
      this.thumb   = root.querySelector('.imgup__thumb');
      this.status  = root.querySelector('.imgup__status');
      this.lightbox= root.querySelector('.imgup__lightbox');
      this.url = null;
      this.hiddenInput = null;
      this._bind();
      this._bindForm();
      patchAjax();
    }

    _bind() {
      var self = this;
      if (this.btn) this.btn.addEventListener('click', function () { self.input.click(); });
      this.input.addEventListener('change', function (e) {
        var f = e.target.files && e.target.files[0];
        if (f) self._handleFile(f);
        e.target.value = '';
      });
      this.root.querySelectorAll('[data-act]').forEach(function (b) {
        b.addEventListener('click', function () {
          var act = b.getAttribute('data-act');
          if (act === 'change') self.input.click();
          else if (act === 'remove') self._clear();
          else if (act === 'view') self._openLightbox();
        });
      });
      if (this.lightbox) {
        this.lightbox.addEventListener('click', function () { self._closeLightbox(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.lightbox && !self.lightbox.hidden) self._closeLightbox();
        });
      }
      if (this.btn) {
        ['dragover','dragenter'].forEach(function(ev){ self.btn.addEventListener(ev, function(e){ e.preventDefault(); self.btn.classList.add('is-drag'); }); });
        ['dragleave','drop'].forEach(function(ev){ self.btn.addEventListener(ev, function(e){ e.preventDefault(); self.btn.classList.remove('is-drag'); }); });
        self.btn.addEventListener('drop', function(e){ var f=e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files[0]; if(f) self._handleFile(f); });
      }
    }

    async _handleFile(file) {
      var allowed = ['image/jpeg','image/png','image/webp','image/heic','image/gif'];
      if (allowed.indexOf(file.type) === -1) { this._setStatus('סוג קובץ לא נתמך (JPG, PNG, WEBP, GIF).', true); return; }
      if (file.size > this.cfg.maxMb * 1024 * 1024) { this._setStatus('הקובץ גדול מדי (מקס ' + this.cfg.maxMb + 'MB).', true); return; }

      var resized = await this._resizeIfNeeded(file, 2000);
      var blobUrl = URL.createObjectURL(resized);
      this._setPreview(blobUrl);
      this._setStatus('מעלה…', false);
      this.root.classList.add('is-uploading');
      try {
        var cdn = await this._upload(resized);
        this.url = cdn;
        this._setPreview(cdn);
        this._inject();
        this._setStatus('✓ התמונה נוספה', false);
      } catch (err) {
        console.error('[ImageUpload]', err);
        var m = (err && err.message) || '';
        if (/not configured|api key|preset/i.test(m)) {
          console.warn('[ImageUpload] Image hosting not configured — set an ImgBB API key in this block\'s settings.');
          this._setStatus('התמונה נבחרה ✓ — אך שמירת התמונות עדיין לא הוגדרה בחנות.', true);
        } else {
          this._setStatus('שמירת התמונה נכשלה — נסו שוב.', true);
        }
        this.url = null;
        this._removeHidden();
      } finally {
        this.root.classList.remove('is-uploading');
      }
    }

    _resizeIfNeeded(file, maxDim) {
      return new Promise(function (resolve) {
        if (file.size < 500 * 1024) { resolve(file); return; }
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function () {
          URL.revokeObjectURL(url);
          var w = img.naturalWidth, h = img.naturalHeight;
          if (w <= maxDim && h <= maxDim) { resolve(file); return; }
          var scale = Math.min(maxDim / w, maxDim / h);
          var nw = Math.round(w * scale), nh = Math.round(h * scale);
          var canvas = document.createElement('canvas');
          canvas.width = nw; canvas.height = nh;
          canvas.getContext('2d').drawImage(img, 0, 0, nw, nh);
          canvas.toBlob(function (blob) { resolve(blob || file); }, 'image/jpeg', 0.85);
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      });
    }

    _upload(file) {
      return this.cfg.service === 'cloudinary' ? this._cloudinary(file) : this._imgbb(file);
    }
    async _imgbb(file) {
      if (!this.cfg.imgbbKey) throw new Error('ImgBB API key not configured');
      var fd = new FormData();
      fd.append('key', this.cfg.imgbbKey);
      fd.append('image', file);
      var r = await fetch('https://api.imgbb.com/1/upload', { method: 'POST', body: fd });
      if (!r.ok) throw new Error('ImgBB ' + r.status);
      var j = await r.json();
      if (!j.success) throw new Error('ImgBB failed');
      return j.data.url;
    }
    async _cloudinary(file) {
      if (!this.cfg.clCloud || !this.cfg.clPreset) throw new Error('Cloudinary not configured');
      var fd = new FormData();
      fd.append('file', file); fd.append('upload_preset', this.cfg.clPreset); fd.append('folder', 'product-uploads');
      var r = await fetch('https://api.cloudinary.com/v1_1/' + this.cfg.clCloud + '/image/upload', { method: 'POST', body: fd });
      var j = await r.json();
      if (j.error) throw new Error(j.error.message);
      return j.secure_url;
    }

    _setPreview(url) {
      if (this.thumb) {
        this.thumb.src = url;
        this.thumb.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      }
      if (this.preview) this.preview.hidden = false;
      if (this.btn) this.btn.hidden = true;
    }
    _clear() {
      this.url = null;
      if (this.thumb) this.thumb.src = '';
      if (this.preview) this.preview.hidden = true;
      if (this.btn) this.btn.hidden = false;
      this._setStatus('', false);
      this._removeHidden();
    }
    _openLightbox() {
      if (!this.lightbox || !this.thumb || !this.thumb.src) return;
      var img = this.lightbox.querySelector('img');
      if (img) img.src = this.thumb.src;
      this.lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    _closeLightbox() { if (this.lightbox) { this.lightbox.hidden = true; document.body.style.overflow = ''; } }

    _setStatus(msg, isErr) {
      if (!this.status) return;
      this.status.textContent = msg;
      this.status.classList.toggle('is-error', !!isErr);
    }

    _bindForm() {
      this.form = this.root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      if (this.form && this.cfg.required) {
        var self = this;
        this.form.addEventListener('submit', function (e) {
          if (!self.url) {
            e.preventDefault(); e.stopImmediatePropagation();
            self._setStatus('יש להוסיף תמונה לפני ההוספה לסל.', true);
            self.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }
    _inject() {
      if (!this.form) return;
      if (!this.hiddenInput) {
        this.hiddenInput = document.createElement('input');
        this.hiddenInput.type = 'hidden';
        this.hiddenInput.name = 'properties[_' + this.cfg.label + ']';
        this.form.appendChild(this.hiddenInput);
      }
      this.hiddenInput.value = this.url;
    }
    _removeHidden() { if (this.hiddenInput) { this.hiddenInput.remove(); this.hiddenInput = null; } }
  }

  function boot() {
    document.querySelectorAll('.imgup').forEach(function (el) {
      if (!el.dataset.init) { el.dataset.init = '1'; new ImageUpload(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  window.ImageUpload = ImageUpload;
})();
